export default "__VITE_ASSET__R_V_tlxn__"